module.exports = __webpack_public_path__ + "img/010.82d8ef01.jpg";